import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { hasPermission } from '../utils/permission';

export function requireAuth(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  
  if (!token || !user) {
    // Redirect to login page if not authenticated
    next({
      path: '/login',
      query: { redirect: to.fullPath } // Store the original path for redirect after login
    });
  } else {
    // Check for permission if defined in route meta
    const permission = to.meta.permission as string | undefined;
    if (permission && !hasPermission(permission)) {
      // User does not have permission, redirect to dashboard or unauthorized page
      // Ideally, we should have an unauthorized page, but for now dashboard is fine
      // or we can just stay on the current page?
      // Let's redirect to dashboard if they try to access a page they can't.
      if (from.path !== '/') {
         next('/');
      } else {
         // Prevent infinite loop if they don't have dashboard permission (unlikely but possible)
         // For now, assume dashboard is safe.
         next(false); 
      }
    } else {
      // Allow access if authenticated and has permission (or no permission required)
      next();
    }
  }
}

export function requireGuest(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  
  if (token && user) {
    // Redirect to dashboard if already authenticated
    next('/');
  } else {
    // Allow access to guest pages (like login)
    next();
  }
}